module.exports = __webpack_public_path__ + "img/295-57a408.png";